(() => {
  const setActiveContent = (section, activeId) => {
    const contentEls = section.querySelectorAll(".specifications__content");

    contentEls.forEach((el) => {
      el.classList.remove("specifications__content--active");
      el.classList.remove("animate");
    });

    const activeContent = section.querySelector(
      `[data-content-tab-id="${activeId}"].specifications__content`
    );

    if (activeContent) {
      activeContent.classList.add("specifications__content--active");

      setTimeout(() => {
        activeContent.classList.add("animate");
      }, 100);
    }
  };

  const toggleTab = (section) => {
    const tabs = section.querySelectorAll(".specifications__tab");

    tabs.forEach((tab) => {
      const currentId = tab.dataset.contentTabId;

      tab.addEventListener("click", (event) => {
        if (
          !event.currentTarget.classList.contains("specifications__tab--active")
        ) {
          tabs.forEach((el) => {
            el.classList.remove("specifications__tab--active");
          });
          tab.classList.add("specifications__tab--active");

          setActiveContent(section, currentId);
        }
      });

      tab.addEventListener("keydown", (event) => {
        if (
          !event.currentTarget.classList.contains(
            "specifications__tab--active"
          ) &&
          event.key === "Enter"
        ) {
          tabs.forEach((el) => {
            el.classList.remove("specifications__tab--active");
          });
          tab.classList.add("specifications__tab--active");

          setActiveContent(section, currentId);
        }
      });
    });
  };

  const setWidthForAfter = (section) => {
    const wrapper = section.querySelector(".specifications__tabs-wrapper");
    if (!wrapper) return;

    const setVariable = (el) => {
      el.style.setProperty("--wrapper-border-width", `0px`);
      const elScrollWidth = el.scrollWidth;
      el.style.setProperty("--wrapper-border-width", `${elScrollWidth}px`);
    };

    setVariable(wrapper);

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        setVariable(entry.target);
      });
    });
    resizeObserver.observe(wrapper);
  };

  const initSection = (section) => {
    if (!section || !section.classList.contains("specifications-section")) return;

    toggleTab(section);
    setWidthForAfter(section);
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
